import { BUSINESS } from '../content'

/**
 * 방침 문서의 개인정보처리자 표기. 모든 문서가 같은 문구를 쓰도록 여기 한 곳에 둔다 —
 * 문서마다 상호·등록번호를 적어 두면 한쪽만 고쳐져 서로 어긋난다.
 *
 * 값은 `content.ts`의 `BUSINESS`에서 온다 (단일 출처, docs/rules.md).
 * "cottonray"만 적으면 법인 식별이 안 되므로 상호·등록번호·대표자를 함께 밝힌다.
 *
 * **등록된 한국어 표기를 괄호에서 지우지 않는다** — 문서는 영어지만 처리자를 식별하는 값은
 * 사업자등록부에 있는 그 표기다. 로마자만 남기면 어느 사업자인지 대조가 안 된다.
 */
export const OPERATOR = `${BUSINESS.nameRoman} (${BUSINESS.name}), business registration number ${BUSINESS.registrationNumber}, represented by ${BUSINESS.representativeRoman} (${BUSINESS.representative}) — hereinafter “the Operator”`
